import * as io from 'io-ts';

const Employment = io.type({
  annualIncome: io.union([io.number, io.null]),
  companyAddress: io.string,
  companyName: io.string,
  currency: io.string,
  occupation: io.string,
  occupationDescription: io.string,
  type: io.string,
});

export const Name = io.intersection([
  io.type({
    familyName: io.string,
    givenName: io.string,
  }),

  io.partial({
    additionalName: io.string,
  }),
]);

const Identity = io.intersection([
  io.type({
    email: io.string,
    name: Name,
    phone: io.string,
  }),

  io.partial({
    birthDate: io.string,
    emailDuplicate: io.boolean,
    emailVerified: io.boolean,
    phoneDuplicate: io.boolean,
    phoneVerified: io.boolean,
    iinShort: io.string,
    iin: io.string,
    hasIIN: io.boolean,
  }),
]);

export const Address = io.type({
  address1: io.string,
  address2: io.string,
  country: io.string,
  locality: io.string,
  postalCode: io.string,
  region: io.string,
});

export const ContactOutgoing = io.type({
  address: Address,
  email: io.string,
  name: Name,
  phone: io.string,
});

export type ContactOutgoing = io.TypeOf<typeof ContactOutgoing>;

export const Contact = io.intersection([
  ContactOutgoing,
  io.type({
    id: io.string,
    buyerID: io.string,
    createdAt: io.string,
    updatedAt: io.string,
  }),
]);

export type Contact = io.TypeOf<typeof Contact>;

const BuyerOptionalOutgoing = io.type({
  contacts: io.record(io.string, Contact),
  createdAt: io.string,
  employment: Employment,
  id: io.string,
  primaryContactID: io.string,
  doNotSellOrShare: io.boolean,
  updatedAt: io.string,
});
const BuyerRequiredOutgoing = io.type({
  identity: Identity,
  languagePreference: io.string,
});

export const Buyer = io.intersection([
  BuyerOptionalOutgoing,
  BuyerRequiredOutgoing,
]);

export const OutgoingBuyer = io.intersection([
  BuyerRequiredOutgoing,
  io.partial(BuyerOptionalOutgoing.props),
]);

export const MaskedBuyerPhoneAndEmail = io.type({
  email: io.string,
  phone: io.string,
});

export type MaskedBuyerPhoneAndEmail = io.TypeOf<
  typeof MaskedBuyerPhoneAndEmail
>;

export type Buyer = io.TypeOf<typeof Buyer>;

export type Name = io.TypeOf<typeof Name>;

export type Address = io.TypeOf<typeof Address>;

export type Identity = io.TypeOf<typeof Identity>;

export type OutgoingBuyer = io.TypeOf<typeof OutgoingBuyer>;

export type OutgoingBuyerWithID = OutgoingBuyer & Pick<Buyer, 'id'>;
